<template>
  <section class="content">
    <!--<template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i :class="alert.icon"></i>
          {{'alert_'+alert.type | translate}}!</h4>
        {{alert.message}}
      </b-alert>
    </template>-->
    <template v-if="newStore">
      <create-store :storeData="storeData" @alert="alert($event)"></create-store>
    </template>
    <template v-else>
      <edit-store :storeData="storeData" :loading="loading" @alert="alert($event)"></edit-store>
    </template>
  </section>
</template>
<script>
  export default {
    data () {
      return {
        test: 'test',
        newStore: false,
        alerts: [],
        storeData: {
          store_number: '',
          name: '',
          gln: '',
          erp_store_id: '',
          street: '',
          street_no: '',
          city: '',
          zip_code: '',
          country: 'DE',
          contact_phone: '',
          contact_name: '',
          contact_email: '',
          order_email: '',
          shipping_name: '',
          shipping_street: '',
          shipping_street_no: '',
          shipping_city: '',
          shipping_zip_code: '',
          shipping_country: 'DE'
        },
        loading: false
      }
    },
    methods: {
      postData () {
        API.put(`accounting/stores/${this.$route.params.id}`, this.storeData)
          .then(response =>{
            let alert = {dismiss: 4, type: 'success', message: 'Update Successful'}
            this.$store.commit('pushAlert', alert)
            this.$router.push('/accounting/stores')
          })
          .catch(error =>{
            if (this.$store.dispatch('checkError', error)) {
              error = error.response.data.error
              let alert = {type: 'danger', dismiss: 4, message: error.message}
              this.$store.commit('pushAlert', alert)
            }
          })
      },
      alert (value) {
        let alert
        if (value.status === 200 || value.status === 204) {
          alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
        } else if (value.status === 201) {
          alert = {dismiss: 4, type: 'success', message: 'Creation Successful', icon: 'icon fa fa-check', show: true}
          setTimeout(() => {
            this.$router.push(`/accounting/companies/${this.$route.params.company_id}/stores/${value.body.id}`)
          }, 5000)
        } else if (value.status === 0) {
          alert = {dismiss: 4, type: 'warning', message: 'Not modified. Store Already Exists', icon: 'icon fa fa-warning', show: true}
        } else {
          alert = {dismiss: 4, type: 'danger', message: 'There was an error', icon: 'icon fa fa-ban', show: true}
        }
        this.$store.commit('pushAlert', alert)
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.$route.params.id !== 'new') {
        this.loading = true
         API.get(`accounting/companies/${this.$route.params.company_id}/stores/${this.$route.params.id}`)
           .then(response =>{
              for (let i in response.data) {
                this.$set(this.storeData, i, response.data[i])
              }
              this.loading = false
            })
           .catch(error =>{
              this.$parent.checkError(error)
              this.loading = false
            })
        } else {
          this.newStore = true
        }
      })
    },
    watch: {
      '$route' () {
        if (this.$route.params.id !== 'new') {
          this.newStore = false
          API.get(`accounting/companies/${this.$route.params.company_id}/${this.$route.params.id}`)
            .then(response =>{
              this.company = response.data
            })
            .catch(error =>{
              this.checkError(error)
            })
        } else {
          this.newCompany = true
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/StoreSingle.vue